"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const confirm_dialog_html_1 = __importDefault(require("./confirm-dialog.html"));
const severityIcons = {
    alert: 'mdi:alert',
    warning: 'material-symbols:warning-rounded',
    info: 'material-symbols:info'
};
const severityIconClasses = {
    alert: 'text-danger',
    warning: 'text-warning',
    info: 'text-info'
};
let ConfirmDialog = class ConfirmDialog extends vue_1.default {
    activeElement;
    $refs;
    severity;
    header;
    modalName;
    message;
    btnOk;
    btnCancel;
    default;
    data() {
        return {
            severityClass: `severity-${this.severity}`,
            iconClass: severityIconClasses[this.severity],
            icon: severityIcons[this.severity]
        };
    }
    beforeMount() {
        this.activeElement = document.activeElement;
        window.addEventListener('keyup', this.onKeyUp);
    }
    mounted() {
        if (this.default === 'cancel') {
            this.$refs.btnCancel.focus();
            return;
        }
        if (this.default === 'ok') {
            this.$refs.btnCancel.focus();
            return;
        }
        this.$refs.container.focus();
    }
    beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp);
        if (this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
        }
        this.activeElement = null;
    }
    ok($event) {
        this.$imodal.close(this.modalName, { ok: true, value: true });
    }
    cancel($event) {
        this.$imodal.close(this.modalName, { cancel: true, value: false });
    }
    onKeyUp(event) {
        if (event.which === 27) {
            event.stopPropagation();
            this.cancel(event);
        }
    }
};
exports.ConfirmDialog = ConfirmDialog;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'alert' }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "severity", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "header", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "modalName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "message", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'OK' }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "btnOk", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Cancel' }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "btnCancel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'cancel' }),
    __metadata("design:type", String)
], ConfirmDialog.prototype, "default", void 0);
exports.ConfirmDialog = ConfirmDialog = __decorate([
    (0, vue_property_decorator_1.Component)({ template: confirm_dialog_html_1.default })
], ConfirmDialog);
//# sourceMappingURL=confirm-dialog.js.map